import { Stack } from "@mui/material";
import type { FC } from "react";
import { DashboardDataSection } from "web_myplann/Dashboard/Components/DashboardDataSection";
import { DashboardImageCardSection } from "web_myplann/Dashboard/Components/DashboardImageCardSection";
import { DashboardShell } from "web_myplann/Dashboard/Components/DashboardShell";
import { FinancialBalance } from "web_myplann/Dashboard/Components/FinancialBalance";

export const DashboardPage: FC = () => (
	<DashboardShell>
		<Stack pb={2}>
			<DashboardDataSection />
			<Stack pt={2.4} px={1.6}>
				<FinancialBalance />
			</Stack>
			<DashboardImageCardSection />
		</Stack>
	</DashboardShell>
);
